import { extend, configure } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import i18n from '@/i18n'

configure({
  defaultMessage: (field, values) => {
    // setujemo default vrednost iz recnika ako nije postavljeno validate-as
    values._field_ = field === '{field}' ? i18n.t(`validation.fields.${values._rule_}`) : field

    const formatting = {
      field: values._field_,
      length: values.length,
      min: values.min,
      max: values.max,
      width: values.width,
      height: values.height,
      size: values.size
    }

    return i18n.t(`validation.messages.${values._rule_}`, i18n.locale, formatting)
  }
})

/**
 * keep if you want all validation rules
 */
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

/**
 * if you don't want to install all rules
 * instead of line -> import * as rules from 'vee-validate/dist/rules'
 * add specific rules, for example -> import { required, email, min } from "vee-validate/dist/rules";
 * and then intall them using:
 * extend("required", required);
 * extend("email", email);
 * extend("min", min);
 */

/**
 * custom validation example
 * you should add appropriate validation field names and messages in translation files (src/locales/[lang].json)
 * example:
 * "validations": {
 *   "fields": {
 *     ...other default field names...
 *     "positive": ""
 *   },
 *   "messages": {
 *     ...other default messages...
 *     "positive": "Field {field} must be a positive number"
 *   }
 * }
 */
extend('positive', (value) => {
  if (value >= 0) {
    return true
  }
})

extend('phoneNumber', (value) => {
  const normalizedNumber = value.replace(/[\\+./-]/g, '')
  const phoneRegex = new RegExp('^(0038\\d|38\\d|0)(\\d{8,9})$')
  const specialCharactersConsecutiveRegex = new RegExp('[-/]{2,}', 'g')
  const multipleNotAllowedChars = value.match(specialCharactersConsecutiveRegex)
  if (phoneRegex.test(normalizedNumber) && !multipleNotAllowedChars) {
    return true
  }
})

extend('phoneNumberWithSpaces', (value) => {
  const normalizedNumber = value.replace(/[\s\\+./-]/g, '')
  const phoneRegex = new RegExp('^(00382\\d|382\\d|0)(\\d{7,9})$')
  const specialCharactersConsecutiveRegex = new RegExp('[-/]{2,}', 'g')
  const multipleNotAllowedChars = value.match(specialCharactersConsecutiveRegex)
  if (phoneRegex.test(normalizedNumber) && !multipleNotAllowedChars) {
    return true
  }
})

extend('internationalPhoneNumber', (value) => {
  const normalizedNumber = value.replace(/[\s\\+./-]/g, '')
  const phoneRegex = new RegExp('^(0038\\d|38\\d|0(?!0)|\\+38\\d)(\\d{8,10})$')
  const specialCharactersConsecutiveRegex = new RegExp('[-/]{2,}', 'g')
  const multipleNotAllowedChars = value.match(specialCharactersConsecutiveRegex)
  if (phoneRegex.test(normalizedNumber) && !multipleNotAllowedChars) {
    return true
  }
})

extend('noSpaces', (value) => {
  const spacesRegex = new RegExp('\\s+', '')
  if (!spacesRegex.test(value)) {
    return true
  }
})

extend('password', (value) => {
  // min 7 characters
  // one upper case
  // one lowercase
  // one number or special char
  const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])((?=.*\\d)|(?=.*\\W))(?=.{7,})')
  return passwordRegex.test(value)
})

extend('confirmPassword', {
  validate (value, args) {
    return value === args[0]
  }
})

extend('otpCode', (value) => {
  const otpRegex = new RegExp('^\\d+$')
  return otpRegex.test(value)
})

extend('currencyRange', {
  ...rules.between
})
extend('decimal', (value) => {
  const decimalRegex = new RegExp('^\\d+\\.?\\d{0,4}$')
  return decimalRegex.test(value)
})

extend('currencyRangeWithComma', {
  validate: (value, { min, max }) => {
    const parsedValue = parseFloat(value.replace(',', '.'))
    const lastCharNotNumber = value.slice(-1) === ',' || value.slice(-1) === '.'
    if (parsedValue > Number(max) || lastCharNotNumber) return
    const regex = new RegExp(`^([${Number(min)}-9](\\.|,)?\\d{0,4}|[1-9]\\d\\d*(\\.|,)?\\d{0,4})$`)
    return regex.test(value)
  },
  params: ['min', 'max']
})

extend('movePassword', (value) => {
  // min 6 characters
  // one upper case
  // one lowercase
  // one number
  const passwordRegex = new RegExp('^(?=.*[A-Z])(?=.*\\d)(?=.{6,})')
  return passwordRegex.test(value)
})
